<template>
  <div class="tips-bar">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'TipsBar',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="less">
.tips-bar{
  height: 33px;
  line-height: 33px;
  background: #F5F5F5;
  text-align: left;
  padding-left: 20px;
  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: #999999;
}
</style>
